<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardBody>
                        <BTabs :active-tab.sync="active_tab">
                            <CTab v-if="get_access('personals_payroll')" :title="$t('sidebars.payroll')">

                                <Salary/>
                            </CTab>
                            <CTab v-if="get_access('personals_report')" :title="$t('payrollReport')">
                                <SalaryReport/>
                            </CTab>
                        </BTabs>


                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';

    var items = [];
    import PersonList from "./PersonList";
    import BTabs from "../../tabs/BTabs";
    import Salary from "./Salary";
    import SalaryReport from "./SalaryReport";

    export default {
        name: 'Login',
        components: {
            BTabs,
            PersonList,
            Salary,
            SalaryReport
        },
        data() {
            return {

                active_tab: 0,

                status_form: 0
            }
        }, mounted() {

            bus.$on("sallary_update", (data) => {
                // alert(data);
                this.active_tab = 1;

            });
        }, watch: {

        },
        methods: {

        }
    }

</script>
